import { ITrangThaiKho } from "../../../model/respone/quan-ly-kho/ITrangThaiKho"
import { ITrangThaiKhoSearchRequest } from "../../../model/request/quan-ly-kho/ITrangThaiKhoSearchRequest"
import { generateActionTypeIds } from "../generateActionTypeIds"
import IGenericActionType from "../IGenericActionType"

export const eTrangThaiKhoActionTypeDefine = {
    LOAD_START: {} as ITrangThaiKhoSearchRequest,
    LOAD_SUCCESS: {} as ITrangThaiKho[],
    LOAD_ERROR: "",

    CLEAR_DATA: undefined,
}

export const eTrangThaiKhoActionTypeIds = generateActionTypeIds(eTrangThaiKhoActionTypeDefine, "TRANG_THAI_KHO")

export type ITrangThaiKhoActions = IGenericActionType<typeof eTrangThaiKhoActionTypeDefine, "TRANG_THAI_KHO">